// extracted by mini-css-extract-plugin
export default {"container":"_2YYb","logo":"dJgs","logoContainer":"_3a0B"};